// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_payment-module__block--13cCL{padding:8px 24px 0}.lawyer_payment-module__icon--1fAqI{vertical-align:bottom;font-size:18px;width:26px;color:inherit;line-height:inherit}.lawyer_payment-module__icon--1fAqI:hover{color:#000}@media screen and (max-width: 48em){.lawyer_payment-module__icon--1fAqI{display:none}}\n", ""]);
// Exports
exports.locals = {
	"block": "lawyer_payment-module__block--13cCL",
	"icon": "lawyer_payment-module__icon--1fAqI"
};
module.exports = exports;
